import { ChangeDetectionStrategy, Component, inject, viewChild } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { svgIconList } from '@shared/svg-icon-list';

@Component({
  selector: 'app-popup-referral',
  imports: [TranslateModule, MatDialogModule, MatTooltipModule, SafeHtmlPipe],
  templateUrl: './popup-referral.component.html',
  styleUrl: './popup-referral.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupReferralComponent {
  data = inject<{ details: any }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<PopupReferralComponent>>(MatDialogRef);

  svg: any = svgIconList;

  private tooltipCode = viewChild('tooltipCode', { read: MatTooltip });
  private tooltipLink = viewChild('tooltipLink', { read: MatTooltip });

  onCopyText(inputElement: any, type: string): void {
    inputElement.select();
    document.execCommand('copy');

    const tooltip = type === 'code' ? this.tooltipCode() : this.tooltipLink();
    tooltip?.show();
    setTimeout(() => tooltip?.hide(), 2000);
  }

  onCloseDialog(event?: Event): void {
    this.dialogRef.close();
  }
}
